import type { FC } from "react";
import type { ContentFileDto } from "shared";
import { Icon } from "../../common/Icon";
import { PreviewAvatar } from "../shared/PreviewAvatar";
import { PreviewMedia } from "../shared/PreviewMedia";
import "./LinkedInPreview.css";

interface LinkedInPreviewProps {
	companyName: string;
	content: string;
	files: ContentFileDto[];
}

export const LinkedInPreview: FC<LinkedInPreviewProps> = ({
	companyName,
	content,
	files,
}) => {
	return (
		<div className="li-preview">
			<div className="li-preview__header">
				<PreviewAvatar
					name={companyName}
					subtitle="1,234 followers"
					size="md"
				/>
				<span className="li-preview__time">2h</span>
			</div>

			<div className="li-preview__content">
				<p className="li-preview__text">{content}</p>
			</div>

			{files.length > 0 && <PreviewMedia files={files} aspectRatio="auto" />}

			<div className="li-preview__stats">
				<span className="li-preview__reactions">
					<span className="li-preview__reaction-icons">
						<span className="li-preview__reaction">👍</span>
						<span className="li-preview__reaction">💡</span>
						<span className="li-preview__reaction">❤️</span>
					</span>
					<span>42</span>
				</span>
				<span className="li-preview__engagement">5 comments · 2 reposts</span>
			</div>

			<div className="li-preview__actions">
				<button type="button" className="li-preview__action">
					<Icon name="thumb_up" size={20} />
					<span>Like</span>
				</button>
				<button type="button" className="li-preview__action">
					<Icon name="chat_bubble" size={20} />
					<span>Comment</span>
				</button>
				<button type="button" className="li-preview__action">
					<Icon name="repeat" size={20} />
					<span>Repost</span>
				</button>
				<button type="button" className="li-preview__action">
					<Icon name="send" size={20} />
					<span>Send</span>
				</button>
			</div>
		</div>
	);
};
